import React from "react";
import { Link } from "react-router-dom";
import { Zap, TrendingUp, ShoppingBag, Globe, Radar, RefreshCw, Twitter, Sparkles, Languages, Wand2 } from "lucide-react";

const FEATURES = [
  { icon: Zap, title: "Autonomous content", body: "GPT-5.6 Terra writes SEO-optimized articles, reviews, and comparison tables — with affiliate links baked in automatically." },
  { icon: ShoppingBag, title: "Live Amazon PA-API", body: "Real product prices, real images, real ASINs. Never a made-up spec sheet." },
  { icon: Wand2, title: "Quick Compare", body: "Type a product name → get a live 5-product comparison article in 60 seconds. Real Amazon data included." },
  { icon: Languages, title: "18 languages", body: "Publish in Hindi, Marathi, Gujarati, Tamil, Telugu, Bengali + 12 more. Parallel generation, one click." },
  { icon: Radar, title: "Refresh Radar", body: "Every article gets a live health score. Bulk-refresh the ones losing rank with one click." },
  { icon: TrendingUp, title: "Live analytics", body: "Real click tracking, per-network breakdowns, weekly digest emails that show what's converting." },
  { icon: Twitter, title: "Auto-share to X", body: "AI composes a scroll-stopping tweet for every article and posts it the moment you publish." },
  { icon: Globe, title: "Public site + SEO", body: "Auto sitemap, JSON-LD structured data, OG cards, and author pages so Google actually indexes you." },
];

export default function FeaturesPage() {
  return (
    <div className="max-w-[1400px] mx-auto px-6 py-16 fade-up">
      <div className="text-center mb-14">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-sky-400 mb-3">— Features</p>
        <h1 className="font-serif text-5xl lg:text-6xl text-sky-100 tracking-tight">
          Every tool an <span className="italic text-sky-400">affiliate marketer</span> needs.
        </h1>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto">Powered by AI you'd otherwise pay $200/mo for. Zero-touch content pipeline.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <div key={i} data-testid={`feature-${i}`} className="border border-slate-800 rounded-xl p-6 hover:border-sky-400/40 transition group">
              <Icon className="w-5 h-5 text-sky-400 mb-4 group-hover:scale-110 transition" strokeWidth={1.5} />
              <h3 className="font-serif text-xl text-sky-100 mb-2">{f.title}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{f.body}</p>
            </div>
          );
        })}
      </div>
      <div className="mt-14 text-center">
        <Link to="/signup" data-testid="features-cta" className="inline-flex items-center gap-2 bg-sky-400 hover:bg-sky-300 text-slate-950 px-8 py-4 rounded-md font-medium text-lg">
          <Sparkles className="w-5 h-5" /> Start free trial
        </Link>
      </div>
    </div>
  );
}
